import apiConfig from './apiConfig.js'
import axios from "axios";
import { EventBus } from "./eventBus.js";

function call(apiUrl, params, success, error) {
    if (!params.lang) {
        var language = navigator.language;
        if (language == "zh-TW" || language == "zh-HK") {
            params.lang = 'zh_HK';
        } else if (language == "zh-CN") {
            params.lang = 'zh_CN';
        } else {
            params.lang = 'en_US';
        }
    }
    var device = (navigator.userAgent).match(/Android|iPhone|iPad|iPod/i);

    if (/Android/i.test(device)) {
        params.device = "aos";
    } else if (/iPhone/i.test(device)) {
        params.device = "ios";
    } else if (/iPad/i.test(device)) {
        params.device = "ios";
    } else {
        params.device = "web";
    }
    params.platformId = 1;
    params.deviceId = "";
    params.osVersion = "";
    params.mobileVersion = "";
    params.screenResolutionWidth = "";
    params.screenResolutionHight = "";
    params.appVersion = "";
    let postParams = transformParams(params)
    // let url = apiConfig.apiDomain.local + apiUrl
    let url = apiConfig.apiDomain + apiUrl
    EventBus.$emit('loading', { turn: 'on' })

    axios.post(url, postParams)
        .then(response => {
            // alert("success" + response)

            if (response.data.errorCode == 0 || response.data.errorCode == undefined) {
                success(response.data)
            } else {
                EventBus.$emit('error', { errMsg: response.data.errorMessage })
                if (typeof (error) == 'function') {
                    error()
                }
            }
            EventBus.$emit('loading', { turn: 'off' })

        })
        .catch(err => {
            EventBus.$emit('error', { errMsg: err })
            if (typeof (error) == 'function') {
                error()
            } else {
                defaultError(err)
            }
        })
}

function defaultError(err) {
    EventBus.$emit('loading', { turn: 'off' })
}
function transformParams(params) {
    let searchParams = new FormData();
    for (var key in params) {
        searchParams.append(key, params[key])

    }
    return searchParams
}
export default {
    getJobFunctionList(data, success, error) {
        let apiUrl = apiConfig.action.getJobFunctionList
        call(apiUrl, data, success, error);
    },
    getOccupationDetail(data, success, error) {
        let apiUrl = apiConfig.action.getOccupationDetail
        call(apiUrl, data, success, error);
    },
    getOccupationList(data, success, error) {
        let apiUrl = apiConfig.action.getOccupationList
        call(apiUrl, data, success, error);
    },
    getJobPostingList(data, success, error) {
        let apiUrl = apiConfig.action.getJobPostingList
        call(apiUrl, data, success, error);
    },
    getJobPostingDetail(data, success, error) {
        let apiUrl = apiConfig.action.getJobPostingDetail
        call(apiUrl, data, success, error);
    },
    getCourseList(data, success, error) {
        let apiUrl = apiConfig.action.getCourseList
        call(apiUrl, data, success, error);
    },
    getCourseDetail(data, success, error) {
        let apiUrl = apiConfig.action.getCourseDetail
        call(apiUrl, data, success, error);
    }, getEducationList(data, success, error) {
        let apiUrl = apiConfig.action.getEducationList
        call(apiUrl, data, success, error);
    }, getHomePage(data, success, error) {
        let apiUrl = apiConfig.action.getHomePage
        call(apiUrl, data, success, error);
    }, getGrantingBody(data, success, error) {
        let apiUrl = apiConfig.action.getGrantingBody
        call(apiUrl, data, success, error);
    }, getAreaOfStudy(data, success, error) {
        let apiUrl = apiConfig.action.getAreaOfStudy
        call(apiUrl, data, success, error);
    }, getLearningMode(data, success, error) {
        let apiUrl = apiConfig.action.getLearningMode
        call(apiUrl, data, success, error);
    }, getArticleList(data, success, error) {
        let apiUrl = apiConfig.action.getArticleList
        call(apiUrl, data, success, error);

    }, getMagazineList(data, success, error) {
        let apiUrl = apiConfig.action.getMagazineList
        call(apiUrl, data, success, error);

    }, getCategoryList(data, success, error) {
        let apiUrl = apiConfig.action.getCategoryList
        call(apiUrl, data, success, error);

    }, getIssueContent(data, success, error) {
        let apiUrl = apiConfig.action.getIssueContent
        call(apiUrl, data, success, error);

    }, getArticleDetail(data, success, error) {
        let apiUrl = apiConfig.action.getArticleDetail
        call(apiUrl, data, success, error);

    }, getOccupationJobList(data, success, error) {
        let apiUrl = apiConfig.action.getOccupationJobList
        call(apiUrl, data, success, error);

    }, getListByOccupation(data, success, error) {
        let apiUrl = apiConfig.action.getListByOccupation
        call(apiUrl, data, success, error);

    }, getListAllByOccupation(data, success, error) {
        let apiUrl = apiConfig.action.getListAllByOccupation
        call(apiUrl, data, success, error);

    }, getDetailLinkCourse(data, success, error) {
        let apiUrl = apiConfig.action.getDetailLinkCourse
        call(apiUrl, data, success, error);

    }, getAllDetailLinkCourse(data, success, error) {
        let apiUrl = apiConfig.action.getAllDetailLinkCourse
        call(apiUrl, data, success, error);

    }, getAssessmentList(data, success, error) {
        let apiUrl = apiConfig.action.getAssessmentList
        call(apiUrl, data, success, error);

    }, getInterestQuestionList(data, success, error) {
        let apiUrl = apiConfig.action.getInterestQuestionList
        call(apiUrl, data, success, error);

    }, getInterestOccupationList(data, success, error) {
        let apiUrl = apiConfig.action.getInterestOccupationList
        call(apiUrl, data, success, error);

    }, getSkillQuestionList(data, success, error) {
        let apiUrl = apiConfig.action.getSkillQuestionList
        call(apiUrl, data, success, error);

    }, getSkillOccupationList(data, success, error) {
        let apiUrl = apiConfig.action.getSkillOccupationList
        call(apiUrl, data, success, error);

    }, getHomeOccupationList(data, success, error) {
        let apiUrl = apiConfig.action.getHomeOccupationList
        call(apiUrl, data, success, error);

    }, getSimilarJobList(data, success, error) {
        let apiUrl = apiConfig.action.getSimilarJobList
        call(apiUrl, data, success, error);

    }, getBgdAssessmentList(data, success, error) {
        let apiUrl = apiConfig.action.getBgdAssessmentList
        call(apiUrl, data, success, error);

    }, findBgdAssTitleByTitle(data, success, error) {
        let apiUrl = apiConfig.action.findBgdAssTitleByTitle
        call(apiUrl, data, success, error);

    }, getBgdAssEducationList(data, success, error) {
        let apiUrl = apiConfig.action.getBgdAssEducationList
        call(apiUrl, data, success, error);

    }, getBgdAssFieldOfStudy(data, success, error) {
        let apiUrl = apiConfig.action.getBgdAssFieldOfStudy
        call(apiUrl, data, success, error);

    }, getResourceGroupList(data, success, error) {
        let apiUrl = apiConfig.action.getResourceGroupList
        call(apiUrl, data, success, error);

    }, getResourceLinkList(data, success, error) {
        let apiUrl = apiConfig.action.getResourceLinkList
        call(apiUrl, data, success, error);

    }, getJobLevelList(data, success, error) {
        let apiUrl = apiConfig.action.getJobLevelList
        call(apiUrl, data, success, error);

    }, getJobTypeList(data, success, error) {
        let apiUrl = apiConfig.action.getJobTypeList
        call(apiUrl, data, success, error);

    }, getCourseLevelList(data, success, error) {
        let apiUrl = apiConfig.action.getCourseLevelList
        call(apiUrl, data, success, error);

    }, getHomePageDraft(data, success, error) {
        let apiUrl = apiConfig.action.getHomePageDraft
        call(apiUrl, data, success, error);

    }, getArticleDetailPreview(data, success, error) {
        let apiUrl = apiConfig.action.getArticleDetailPreview
        call(apiUrl, data, success, error);

    }, sendEmail(data, success, error) {
        let apiUrl = apiConfig.action.sendEmail
        call(apiUrl, data, success, error);

    }, getInformationCentreList(data, success, error) {
        let apiUrl = apiConfig.action.getInformationCentreList
        call(apiUrl, data, success, error);

    }, getHomeJobList(data, success, error) {
        let apiUrl = apiConfig.action.getHomeJobList
        call(apiUrl, data, success, error);

    }, getCourseListInHomepage(data, success, error) {
        let apiUrl = apiConfig.action.getCourseListInHomepage
        call(apiUrl, data, success, error);

    }, getShortTermList(data, success, error) {
        let apiUrl = apiConfig.action.getShortTermList
        call(apiUrl, data, success, error);

    }, getJobCourseList(data, success, error) {
        let apiUrl = apiConfig.action.getJobCourseList
        call(apiUrl, data, success, error);

    }, getAllJobCourseList(data, success, error) {
        let apiUrl = apiConfig.action.getAllJobCourseList
        call(apiUrl, data, success, error);

    }, geCourseQuickQuery(data, success, error) {
        let apiUrl = apiConfig.action.geCourseQuickQuery
        call(apiUrl, data, success, error);

    }, getJobOccupationList(data, success, error) {
        let apiUrl = apiConfig.action.getJobOccupationList
        call(apiUrl, data, success, error);

    }, getAllJobOccupationList(data, success, error) {
        let apiUrl = apiConfig.action.getAllJobOccupationList
        call(apiUrl, data, success, error);

    }, getCourseOccupationList(data, success, error) {
        let apiUrl = apiConfig.action.getCourseOccupationList
        call(apiUrl, data, success, error);

    }, getAllCourseOccupationList(data, success, error) {
        let apiUrl = apiConfig.action.getAllCourseOccupationList
        call(apiUrl, data, success, error);

    }, getQuizSwitch(data, success, error) {
        let apiUrl = apiConfig.action.getQuizSwitch
        call(apiUrl, data, success, error);

    }, saveQuizResult(data, success, error) {
        let apiUrl = apiConfig.action.saveQuizResult
        call(apiUrl, data, success, error);

    }, checkSystemTheme(data, success, error) {
        let apiUrl = apiConfig.action.checkSystemTheme
        call(apiUrl, data, success, error);

    }
}